import { useSelector } from "react-redux";
import BreadCrumbs from "../../components/General/BreadCrumbs";
import ShowroomHero from "../../components/Showrooms/ShowroomHero";
import { useEffect, useRef, useState } from "react";
import { getBannersFiltered, getSingleServiceCenter } from "../../utils/fetcher";
import SidebarBox from "../../components/General/SidebarBox";
import ShowroomSocial from "../../components/Showrooms/ShowroomSocial";
import LoadingSkeleton from "../../components/UI/LoadingSkeleton";
import BrandsList from "../../components/Vehicles/BrandsList";
import branchStyle from "../../components/Showrooms/ShowroomSocial/index.module.css";
import style from "./index.module.css";
import { useScrollToTop } from "../../utils/generalUtils";
import axios from "axios";
import Banner from "../../components/Vehicles/Banner";
import { Bus, Car, Motorcycle, Truck } from "../../components/Icons";
import { useTranslation } from "../../hooks/useTranslation";
import { useParams } from "react-router-dom";

const SingleServiceCenter = () => {
  const { centerID } = useParams<{ centerID: string }>();
  const { locale } = useTranslation();

  useScrollToTop();

  const initialMount = useRef<boolean>(true);

  const [componentData, setComponentData] = useState<{
    isFetching: boolean;
    data: {
      center: any;
      extraBreadCrumbs: { text: string; link: string }[];
      banners: any;
    };
  }>({
    isFetching: true,
    data: {
      center: null,
      extraBreadCrumbs: [],
      banners: null,
    },
  });

  useEffect(() => {
    if (!initialMount.current) {
      setComponentData((current) => ({
        ...current,
        isFetching: true,
      }));
    }
    let data: any = {
      center: null,
      extraBreadCrumbs: [],
      banners: null,
    };
    (async () => {
      await axios
        .all([getSingleServiceCenter(+centerID), getBannersFiltered("single_service_center_banner", "", centerID)])
        .then((res) => {
          data.center = res[0].data?.service_center;
          data.extraBreadCrumbs.push({
            text: data.center.name,
            link: "",
          });
          data.banners = res[1].data?.banners;
        })
        .catch((error) => {});
      initialMount.current = false;
      setComponentData({
        isFetching: false,
        data,
      });
    })();
  }, [centerID]);

  return (
    <>
      {/* <div className="main_section">
        <div className="container-lg">
          <div className="section_content_padding">
            <BreadCrumbs
              pages={[
                { text: locale("home"), link: "/" },
                {
                  text: locale("service_centers"),
                  link: "/service-centers/bus",
                },
                ...(componentData.data.extraBreadCrumbs.length > 0
                  ? componentData.data.extraBreadCrumbs
                  : [{ text: "", link: "" }]),
              ]}
              isLoading={componentData.isFetching}
            />
          </div>
        </div>
      </div> */}
      <div className="main_section">
        <div className="container-lg">
          <div className="section_content_padding">
            <ShowroomHero
              cover={componentData.data.center?.cover}
              logo={componentData.data.center?.logo}
              name={componentData.data.center?.name}
              note={componentData.data.center?.address}
              phone={componentData.data.center?.phone}
              isServiceCenter={true}
              isLoading={componentData.isFetching}
            />
          </div>
        </div>
      </div>
      <div className="main_section">
        <div className="container-lg">
          <div className="section_content_padding">
            <div className={`${style.page_row} row`}>
              <div className="col-lg-4">
                <SidebarBox>
                  {componentData.isFetching ? (
                    <LoadingSkeleton count={5} />
                  ) : (
                    <ShowroomSocial
                      isServiceCenter={true}
                      social={{
                        fb: componentData.data.center?.facebook,
                        ig: componentData.data.center?.insta,
                        yt: componentData.data.center?.yt,
                        website: componentData.data.center?.website,
                      }}
                      about={componentData.data.center?.description}
                      address={componentData.data.center?.address}
                      daysOff={componentData.data.center?.days_off}
                      working_hours={componentData.data.center?.working_hours}
                      region={{
                        name: componentData.data.center?.region.name,
                        city: {
                          name: componentData.data.center?.region.city.name,
                        },
                      }}
                    />
                  )}
                </SidebarBox>
              </div>
              <div className="col-lg-8">
                {((componentData.data.center && !componentData.isFetching) || componentData.isFetching) &&
                  (componentData.isFetching ? (
                    <LoadingSkeleton count={8} />
                  ) : (
                    <>
                      {componentData.data.banners && componentData.data.banners.length > 0 && (
                        <div style={{ marginBottom: "20px" }}>
                          <Banner
                            banners={componentData.data.banners.map((banner: any) => ({
                              image: banner.image,
                              url: banner.link,
                            }))}
                            bannerStyle="small"
                            redirection="newPage"
                          />
                        </div>
                      )}
                      {componentData.data.center.brands && componentData.data.center.brands.length > 0 && (
                        <div className={style.page_section}>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "start",
                              gap: 5,
                              alignItems: "center",
                            }}
                          >
                            <h3
                              style={{
                                margin: 0,
                              }}
                              className="main_section__titile"
                            >
                              Brands
                            </h3>
                            <div
                              style={{
                                display: "flex",
                                gap: 5,
                                alignItems: "center",
                              }}
                            >
                              {componentData.data.center?.car ? (
                                <span>
                                  <Car width="40" height="40" color="black" />
                                </span>
                              ) : null}
                              {componentData.data.center?.truck ? (
                                <span>
                                  <Truck width="40" height="40" color="black" />
                                </span>
                              ) : null}
                              {componentData.data.center?.bus ? (
                                <span>
                                  <Bus width="40" height="40" color="black" />
                                </span>
                              ) : null}
                              {componentData.data.center?.motorcycle ? (
                                <span>
                                  <Motorcycle width="40" height="40" color="black" />
                                </span>
                              ) : null}
                            </div>
                          </div>
                          <BrandsList
                            brands={componentData.data.center.brands.map((brand: any) => ({
                              name: brand.name,
                              image: brand.logo,
                              link: "#",
                            }))}
                          />
                        </div>
                      )}
                      {componentData.data.center.services && componentData.data.center.services.length > 0 && (
                        <div className={style.page_section}>
                          <h3 className="main_section__titile">{locale("servicecs")}</h3>
                          <BrandsList
                            brands={componentData.data.center.services.map((service: any) => ({
                              name: service.title,
                              image: service.icon,
                              link: "#",
                            }))}
                          />
                        </div>
                      )}
                      {componentData.data.center.branches && componentData.data.center.branches.length > 0 && (
                        <div className={style.page_section}>
                          <h3 className="main_section__titile">Branches</h3>
                          {componentData.data.center.branches.map((branch: any) => (
                            <div key={branch.id} className={branchStyle.single_branch}>
                              <p>
                                <b>{branch.name}:</b> {branch.address}
                              </p>
                              <span>{branch.phone}</span>
                            </div>
                          ))}
                        </div>
                      )}
                    </>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SingleServiceCenter;
